"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _webApiClient = _interopRequireDefault(require("@jusda-tools/web-api-client"));
var _jusdaPublicmethod = require("@jusda-tools/jusda-publicmethod");
var _AuthLogin = require("./AuthLogin");
var _envConfig = _interopRequireDefault(require("./envConfig.js"));
var _token = require("./token.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var authMobileUrl = _envConfig["default"].authMobileUrl,
  authUrl = _envConfig["default"].authUrl,
  loginOutUrl = _envConfig["default"].loginOutUrl;
var JusdaUserInfo = exports["default"] = /*#__PURE__*/function () {
  function JusdaUserInfo() {
    (0, _classCallCheck2["default"])(this, JusdaUserInfo);
    this.userInfo = window.jusdaUserInfo;
  }
  return (0, _createClass2["default"])(JusdaUserInfo, [{
    key: "getFullInfo",
    value: function getFullInfo() {
      return this.userInfo;
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(urlParam, newClientId) {
        var _window, jusdaBaseConfig, _ref, isMobile, clientId, isCustomLogout, cookieTools, token, session, redirectUrl, newAuthMobileUrl;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _window = window, jusdaBaseConfig = _window.jusdaBaseConfig;
              _ref = jusdaBaseConfig || {}, isMobile = _ref.isMobile, clientId = _ref.clientId, isCustomLogout = _ref.isCustomLogout;
              if (!isCustomLogout) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              cookieTools = new _jusdaPublicmethod.CookieTools();
              token = _token.tokenFn.getToken(); // 退出接口header带上JSESSION (解决项目和登录域名不一致的问题)
              session = cookieTools.get('JSESSION') || '';
              _webApiClient["default"].interceptors.request.use(function (url, options) {
                return {
                  url: url,
                  options: _objectSpread(_objectSpread({}, options), {}, {
                    headers: _objectSpread(_objectSpread({}, options.headers), {}, {
                      "JSESSION": "".concat(session)
                    })
                  })
                };
              }, {
                global: false
              });
              _context.next = 10;
              return _webApiClient["default"].post("".concat(loginOutUrl, "/").concat(token));
            case 10:
              cookieTools.removeToken();
              redirectUrl = urlParam ? encodeURIComponent(urlParam) : encodeURIComponent("".concat((0, _AuthLogin.getRuntimeRedirectUrl)()));
              newAuthMobileUrl = authMobileUrl + '?clientId=' + (newClientId || clientId);
              window.location.href = "".concat(isMobile ? newAuthMobileUrl : authUrl, "&redirectUrl=").concat(redirectUrl, "&state=").concat(jusdaBaseConfig ? jusdaBaseConfig.state || 'placeholder' : 'placeholder', "&responseType=").concat(jusdaBaseConfig ? jusdaBaseConfig.responseType || 'code' : 'code', "&scopeCodes=").concat(jusdaBaseConfig ? jusdaBaseConfig.scopeCodes || '' : '', "&t=").concat(new Date().getTime());
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function logout(_x, _x2) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }]);
}();